import { useCallback, useState } from 'react';

import {
	updateAvailability as updateAvailabilityAction,
	deleteAvailability as deleteAvailabilityAction,
} from 'lib/models/order';

function useInAppAvailabilitiesActions() {
	const [loading, setLoading] = useState(false);

	const updateAvailability = useCallback(async (availability: InAppAvailability) => {
		setLoading(true);
		await updateAvailabilityAction(availability);
		setLoading(false);
	}, []);

	const deleteAvailability = useCallback(async (availabilityId: string) => {
		setLoading(true);
		const result = await deleteAvailabilityAction(availabilityId);
		setLoading(false);
		return result;
	}, []);

	return {
		loading,
		updateAvailability,
		deleteAvailability,
	};
}

export default useInAppAvailabilitiesActions;
